// src/pages/Companies/styles.ts
import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
`;

export const Title = styled.h3`
  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 900;
  color: ${(props) => props.theme.tokens.colors.ink};
`;
